import React from 'react';
import { formatTitleVersions } from '../../common/ProductUtilities';

const TitleVersionRenderer = (props: any) => {
  const title = props?.data?.title ?? '';

  return (
    <div>
      {`${title}`}
      <span className="supplementary-info">
        {formatTitleVersions(
          props?.data?.versions,
          props?.data?.exclusiveReleaseAccountName
        )}
      </span>
    </div>
  );
};

export default TitleVersionRenderer;
